import {
	FETCH_FERIES_BEGIN,
	FETCH_FERIES_ERROR,
	FETCH_FERIES_SUCCESS,
} from "../actions/feriesActions"

// Jours fériés / chômés (GE-11) — /configuration → Dépannage → Jours fériés.
// `data` = payload complet du GET (canton, catalogue, jours…), remplacé par
// chaque mutation (liste fraîche).
const initialState = {
	data: null,
	fetchFeries: { loading: false, error: false },
}

export default function feriesReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_FERIES_BEGIN:
			return { ...state, fetchFeries: { loading: true, error: false } }
		case FETCH_FERIES_SUCCESS:
			return {
				...state,
				data: action.payload.data,
				fetchFeries: { loading: false, error: false },
			}
		case FETCH_FERIES_ERROR:
			return {
				...state,
				fetchFeries: { loading: false, error: action.payload.error },
			}
		default:
			return state
	}
}
